import { render, staticRenderFns } from "./GeneralInformation.vue?vue&type=template&id=01b36510&scoped=true"
import script from "./GeneralInformation.vue?vue&type=script&lang=js"
export * from "./GeneralInformation.vue?vue&type=script&lang=js"
import style0 from "./GeneralInformation.vue?vue&type=style&index=0&id=01b36510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b36510",
  null
  
)

export default component.exports